import { limitArrayHead } from 'functions/array'
import { ButtonType, PhotoRatingState } from 'reducers/rating/PhotoRatingState'

/**
 * https://redmine.mamba.ru/issues/120253#note-6
 */
export const LIMIT = 50

/**
 * @param state
 * @param type
 * Особенности работы при revert
 * При возврате назад, мы прибавляем + 1 к revertCounter,
 * При голосовании, если мы голосуем на фото, на которое вернулись, мы уменьшаем revertCounter,
 * До тех пор пока не равен будет 0.
 * Когда revertCounter === 0, это значит мы проголосовали за последнее фото из пройденных,
 * и вернулись на то фото, с которой начали свое предыдущее путешествие назад.
 * И выставляем revertCounter в null
 */
export const changePhotosStateBeforeFetch = (
  state: PhotoRatingState,
  type: ButtonType
) => {
  const [head, ...tail] = state.votingPhotos

  const _revertPhotos =
    // eslint-disable-next-line no-nested-ternary
    state.revertCounter === null
      ? state.revertCounter
      : state.revertCounter === 1
      ? null
      : state.revertCounter - 1

  const _pastVotingPhotos = limitArrayHead(state.pastVotingPhotos, LIMIT)

  return {
    voting: true,
    [type]: true,
    error: undefined,
    errorStatus: undefined,
    votingPhotos: tail,
    pastVotingPhotos: [..._pastVotingPhotos, head],
    votedCounter:
      state.revertCounter === null
        ? state.votedCounter + 1
        : state.votedCounter,
    revertCounter: _revertPhotos,
  }
}
